import styled from 'styled-components'
import truckSvg from 'resources/svg/icons/delivery.svg'
import giftSvg from 'resources/svg/icons/gift-white.svg'
import { font } from 'lib/core/resources/helpers/styled'

export const SlideContent = styled.div`
  text-align: center;
  background: ${props => props.theme.palette.general.dark};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;

  p {
    margin: 0;
    color: ${props => props.theme.palette.general.light};
    text-transform: uppercase;
    font: ${font('default', 'bold', '14px/1.5')};

    a {
      color: ${props => props.theme.palette.general.light};
      text-decoration: none;
    }
  }

  .icon {
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    margin-bottom: 3px;
    background: no-repeat 50% 50% / contain;

    &-truck {
      background-image: url(${truckSvg});
    }

    &-gift {
      background-image: url(${giftSvg});
    }
  }
`
